module.exports = __webpack_public_path__ + "img/23.90974651.jpg";